/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    ProviderCredentialV2OrderValue,
    ProviderCredentialV2OrderValueFromJSON,
    ProviderCredentialV2OrderValueFromJSONTyped,
    ProviderCredentialV2OrderValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialV2Query
 */
export interface ProviderCredentialV2Query {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof ProviderCredentialV2Query
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof ProviderCredentialV2Query
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof ProviderCredentialV2Query
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof ProviderCredentialV2Query
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2Query
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2Query
     */
    orderByDescending?: boolean;
    /**
     * 
     * @type {ProviderCredentialV2OrderValue}
     * @memberof ProviderCredentialV2Query
     */
    orderValue?: ProviderCredentialV2OrderValue;
    /**
     * 
     * @type {number}
     * @memberof ProviderCredentialV2Query
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProviderCredentialV2Query
     */
    limit?: number | null;
}

export function ProviderCredentialV2QueryFromJSON(json: any): ProviderCredentialV2Query {
    return ProviderCredentialV2QueryFromJSONTyped(json, false);
}

export function ProviderCredentialV2QueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialV2Query {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'orderByDescending': !exists(json, 'orderByDescending') ? undefined : json['orderByDescending'],
        'orderValue': !exists(json, 'orderValue') ? undefined : ProviderCredentialV2OrderValueFromJSON(json['orderValue']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function ProviderCredentialV2QueryToJSON(value?: ProviderCredentialV2Query | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'showDisabled': value.showDisabled,
        'orderByDescending': value.orderByDescending,
        'orderValue': ProviderCredentialV2OrderValueToJSON(value.orderValue),
        'offset': value.offset,
        'limit': value.limit,
    };
}


